<div class="budget-owner">
  <div class="owner-label">Budget Owner:</div>
  <div class="owner-name">{{ ownerName }}</div>
</div>
